// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Entire page background */
body,
html {
  margin: 0;
  padding: 0;
  background-color: #ffffff; /* Blue background */
}

/* Page body */
.page-body {
  background-color: transparent; /* Let the main background show through */
}
.page-title {
  font-size: 1.5rem;
}
/* Remove underline + blue color from breadcrumb link */
.breadcrumb-link {
  text-decoration: none;
  color: #000;  /* or your preferred color */
}

.breadcrumb-link:hover {
  text-decoration: none;
  color: #000; /* same color on hover */
}

/* Make it responsive */
@media (max-width: 768px) {
  .page-title {
    font-size: 16px;
  }
  .breadcrumb {
    font-size: 12px;
    text-align: left; /* stack neatly on small screens */
    margin-top: 8px;
  }
}

.breadcrumb {
  font-size: 0.95rem;
  color: #555;
}

@media (max-width: 576px) {
  .page-title,
  .breadcrumb {
    text-align: center;
    width: 100%;
        font-size: 12px;
    margin-bottom: 0.5rem;
  }
}

/* Main content container */
.terms-container {
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
  font-family: "Roboto", sans-serif;
  line-height: 1.8;
  background-color: white; /* White inner content */
  color: #111;
  border-radius: 8px;
  /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1); */
}
/* Remove underline + blue from breadcrumb links */
.breadcrumb-link {
  text-decoration: none;
  color: #000;
}

.breadcrumb-link:hover {
  text-decoration: none;
  color: #000;
}

/* Make current item inline and aligned */
.breadcrumb-current {
  display: inline;   /* ✅ keeps it on same line */
  font-weight: 600;  /* bold like before */
  color: #000;
  white-space: nowrap; /* prevent breaking into new line */
}

/* Page Title */
.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #244b32;
  margin-bottom: 30px;
}

/* Section Title */
.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a411f;
  margin-top: 20px;
}

.bold {
  font-weight: 700;
}

.note {
  color: #000;
  font-weight: 700;
  margin-top: 20px;
}

/* Links */
a {
  color: #000;
  text-decoration: none;
}


/* Responsive - Tablet and below */
@media (max-width: 768px) {
  .terms-container {
    padding: 10px;
    margin: 20px 10px;
  }

  .page-title {
    font-size: 22px;
  }

  .section-title {
    font-size: 18px;
  }
}

/* Responsive - Large Desktop (1920px and up) */
@media (min-width: 1600px) {
  .terms-container {
    max-width: 1400px;
    padding: 0 40px;
  }

  .page-title {
    font-size: 32px;
  }

  .section-title {
    font-size: 22px;
  }
}
/* Default table (desktop) */
.wp-block-table table {
  width: 100%;
  border-collapse: collapse;
}

.wp-block-table table td,
.wp-block-table table th {
  border: 1px solid #5a5959;
  padding: 10px;
  text-align: left;
}

/* Mobile: keep 2-column structure, allow horizontal scroll */
@media (max-width: 768px) {
  .wp-block-table {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .wp-block-table table {
    width: 100%;
    table-layout: fixed;
  }

  .wp-block-table td,
  .wp-block-table th {
    font-size: 14px;
    padding: 8px;
    word-wrap: break-word;
  }
}


.table-responsive {
  width: 100%;
  overflow-x: auto;   /* enables scroll for small screens */
}

.responsive-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  min-width: 600px; /* keeps structure intact */
}

.responsive-table th,
.responsive-table td {
  border: 1px solid #000; /* black borders for lines */
  padding: 10px;
  text-align: left;
  vertical-align: top;
  word-wrap: break-word;
}

.responsive-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .table-responsive {
    overflow-x: auto;    /* horizontal scroll instead of breaking layout */
    -webkit-overflow-scrolling: touch;
  }

  .responsive-table {
    min-width: 600px;    /* table stays full with lines */
  }

  .responsive-table th,
  .responsive-table td {
    font-size: 14px;     /* smaller text for mobile */
    padding: 8px;
  }
}

/* Optional: smooth scroll bar for mobile */
.table-responsive::-webkit-scrollbar {
  height: 6px;
}
.table-responsive::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/compliancepages/TermsAndConditions.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;;EAEE,SAAS;EACT,UAAU;EACV,yBAAyB,EAAE,oBAAoB;AACjD;;AAEA,cAAc;AACd;EACE,6BAA6B,EAAE,yCAAyC;AAC1E;AACA;EACE,iBAAiB;AACnB;AACA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,WAAW,GAAG,4BAA4B;AAC5C;;AAEA;EACE,qBAAqB;EACrB,WAAW,EAAE,wBAAwB;AACvC;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB,EAAE,kCAAkC;IACpD,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;;IAEE,kBAAkB;IAClB,WAAW;QACP,eAAe;IACnB,qBAAqB;EACvB;AACF;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB,EAAE,wBAAwB;EACjD,WAAW;EACX,kBAAkB;EAClB,+CAA+C;AACjD;AACA,kDAAkD;AAClD;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,eAAe,IAAI,4BAA4B;EAC/C,gBAAgB,GAAG,qBAAqB;EACxC,WAAW;EACX,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,qBAAqB;AACvB;;;AAGA,kCAAkC;AAClC;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,4BAA4B;AAC5B;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,YAAY;IACZ,qBAAqB;EACvB;AACF;;;AAGA;EACE,WAAW;EACX,gBAAgB,IAAI,qCAAqC;AAC3D;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA;;EAEE,sBAAsB,EAAE,4BAA4B;EACpD,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE;IACE,gBAAgB,KAAK,iDAAiD;IACtE,iCAAiC;EACnC;;EAEA;IACE,gBAAgB,KAAK,gCAAgC;EACvD;;EAEA;;IAEE,eAAe,MAAM,4BAA4B;IACjD,YAAY;EACd;AACF;;AAEA,2CAA2C;AAC3C;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* Entire page background */\r\nbody,\r\nhtml {\r\n  margin: 0;\r\n  padding: 0;\r\n  background-color: #ffffff; /* Blue background */\r\n}\r\n\r\n/* Page body */\r\n.page-body {\r\n  background-color: transparent; /* Let the main background show through */\r\n}\r\n.page-title {\r\n  font-size: 1.5rem;\r\n}\r\n/* Remove underline + blue color from breadcrumb link */\r\n.breadcrumb-link {\r\n  text-decoration: none;\r\n  color: #000;  /* or your preferred color */\r\n}\r\n\r\n.breadcrumb-link:hover {\r\n  text-decoration: none;\r\n  color: #000; /* same color on hover */\r\n}\r\n\r\n/* Make it responsive */\r\n@media (max-width: 768px) {\r\n  .page-title {\r\n    font-size: 16px;\r\n  }\r\n  .breadcrumb {\r\n    font-size: 12px;\r\n    text-align: left; /* stack neatly on small screens */\r\n    margin-top: 8px;\r\n  }\r\n}\r\n\r\n.breadcrumb {\r\n  font-size: 0.95rem;\r\n  color: #555;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .page-title,\r\n  .breadcrumb {\r\n    text-align: center;\r\n    width: 100%;\r\n        font-size: 12px;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n}\r\n\r\n/* Main content container */\r\n.terms-container {\r\n  max-width: 1200px;\r\n  margin: 40px auto;\r\n  padding: 0 20px;\r\n  font-family: \"Roboto\", sans-serif;\r\n  line-height: 1.8;\r\n  background-color: white; /* White inner content */\r\n  color: #111;\r\n  border-radius: 8px;\r\n  /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1); */\r\n}\r\n/* Remove underline + blue from breadcrumb links */\r\n.breadcrumb-link {\r\n  text-decoration: none;\r\n  color: #000;\r\n}\r\n\r\n.breadcrumb-link:hover {\r\n  text-decoration: none;\r\n  color: #000;\r\n}\r\n\r\n/* Make current item inline and aligned */\r\n.breadcrumb-current {\r\n  display: inline;   /* ✅ keeps it on same line */\r\n  font-weight: 600;  /* bold like before */\r\n  color: #000;\r\n  white-space: nowrap; /* prevent breaking into new line */\r\n}\r\n\r\n/* Page Title */\r\n.page-title {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  color: #244b32;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n/* Section Title */\r\n.section-title {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #1a411f;\r\n  margin-top: 20px;\r\n}\r\n\r\n.bold {\r\n  font-weight: 700;\r\n}\r\n\r\n.note {\r\n  color: #000;\r\n  font-weight: 700;\r\n  margin-top: 20px;\r\n}\r\n\r\n/* Links */\r\na {\r\n  color: #000;\r\n  text-decoration: none;\r\n}\r\n\r\n\r\n/* Responsive - Tablet and below */\r\n@media (max-width: 768px) {\r\n  .terms-container {\r\n    padding: 10px;\r\n    margin: 20px 10px;\r\n  }\r\n\r\n  .page-title {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .section-title {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n/* Responsive - Large Desktop (1920px and up) */\r\n@media (min-width: 1600px) {\r\n  .terms-container {\r\n    max-width: 1400px;\r\n    padding: 0 40px;\r\n  }\r\n\r\n  .page-title {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .section-title {\r\n    font-size: 22px;\r\n  }\r\n}\r\n/* Default table (desktop) */\r\n.wp-block-table table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.wp-block-table table td,\r\n.wp-block-table table th {\r\n  border: 1px solid #5a5959;\r\n  padding: 10px;\r\n  text-align: left;\r\n}\r\n\r\n/* Mobile: keep 2-column structure, allow horizontal scroll */\r\n@media (max-width: 768px) {\r\n  .wp-block-table {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .wp-block-table table {\r\n    width: 100%;\r\n    table-layout: fixed;\r\n  }\r\n\r\n  .wp-block-table td,\r\n  .wp-block-table th {\r\n    font-size: 14px;\r\n    padding: 8px;\r\n    word-wrap: break-word;\r\n  }\r\n}\r\n\r\n\r\n.table-responsive {\r\n  width: 100%;\r\n  overflow-x: auto;   /* enables scroll for small screens */\r\n}\r\n\r\n.responsive-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  table-layout: auto;\r\n  min-width: 600px; /* keeps structure intact */\r\n}\r\n\r\n.responsive-table th,\r\n.responsive-table td {\r\n  border: 1px solid #000; /* black borders for lines */\r\n  padding: 10px;\r\n  text-align: left;\r\n  vertical-align: top;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.responsive-table th {\r\n  background-color: #f2f2f2;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Mobile responsiveness */\r\n@media (max-width: 768px) {\r\n  .table-responsive {\r\n    overflow-x: auto;    /* horizontal scroll instead of breaking layout */\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .responsive-table {\r\n    min-width: 600px;    /* table stays full with lines */\r\n  }\r\n\r\n  .responsive-table th,\r\n  .responsive-table td {\r\n    font-size: 14px;     /* smaller text for mobile */\r\n    padding: 8px;\r\n  }\r\n}\r\n\r\n/* Optional: smooth scroll bar for mobile */\r\n.table-responsive::-webkit-scrollbar {\r\n  height: 6px;\r\n}\r\n.table-responsive::-webkit-scrollbar-thumb {\r\n  background: #999;\r\n  border-radius: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
